var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-btn',{staticClass:"ml-2",attrs:{"pressed":_vm.fieldObj[_vm.name],"size":"sm","variant":"outline-dark"},on:{"click":_vm.toggle}},[_c('i',{staticClass:"fas",class:'fa-' + _vm.ico})])
}
var staticRenderFns = []

export { render, staticRenderFns }